import { Chip } from "@mui/material";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  ServiceMarketplaceDto,
  ServiceMarketplaceTranslationDto,
} from "@green0meter/api-client";

import { StyledCard, ServiceImage, CardContent } from "./ServiceCard.styled";

import { Box, Button, Stack, Typography, Divider } from "@components/base";

interface Component {
  service: ServiceMarketplaceDto;
}

const Component: FC<Component> = ({ service }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const getTranslation = (): ServiceMarketplaceTranslationDto | undefined => {
    const currentLocale = i18n.language;

    let translation = service.translations?.find(
      (trans) => trans.languages_code === currentLocale
    );

    if (!translation) {
      const languageCode = currentLocale.split('-')[0];

      translation = service.translations?.find(
        (trans) => trans.languages_code.startsWith(languageCode)
      );
    }

    if (!translation && service.translations?.length > 0) {
      translation = service.translations[0];
    }

    return translation;
  };

  const translation = getTranslation();

  const handleClickExplore = (): void => {
    navigate(`/services-marketplace/${service.id}`);
  };

  return (
    <StyledCard>
      {service.preview_image && (
        <ServiceImage
          src={service.preview_image}
          alt={translation?.title || "Service image"}
        />
      )}
      <CardContent>
        <Stack justifyContent="space-between" height="100%" spacing={2}>
          <Stack spacing={2}>
            <Box>
              <Chip
                label={
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="caption1">
                      {t("servicesMarketplace.knowledgeDropInside")}
                    </Typography>
                  </Stack>
                }
                variant="filled"
                color="primary"
                size="medium"
              />
            </Box>
            <Typography variant="h6">{translation?.title || `Service ${service.id}`}</Typography>
            <Typography
              variant="body2"
              sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
                overflow: 'hidden',
              }}
              dangerouslySetInnerHTML={{ __html: translation?.description || '' }}
            />
          </Stack>
          <Stack spacing={2}>
            <Divider />
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography fontSize={12}>
                {t(`serviceMarketplace.${service.sertice_type}`)}
              </Typography>
              <Button variant="contained" onClick={handleClickExplore}>
                {t("servicesMarketplace.explore")}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default Component;
